// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__CpAj0","label":"Section_label__1QdwN","contentWrap":"Section_contentWrap__31KJz","footer":"Section_footer__3x0cP","footerInner":"Section_footerInner__1psVT"};